'use client';

import { AuthenticatedNavigation } from './AuthenticatedNavigation';
import { GuestNavigation } from './GuestNavigation';

export const BottomNavigation = ({ loggedin }: { loggedin: boolean }) => {
  return loggedin ? <AuthenticatedNavigation /> : <GuestNavigation />;
};
